import { ButtonComp } from 'atoms/Buttons';
import React, { useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CarauselComp from 'atoms/Carausel/Presentation/CarauselComp';
import SampleArrowNext from '../../../OffersAndPromotions/Presentation/SampleArrowNext';
import SampleArrowPrev from '../../../OffersAndPromotions/Presentation/SampleArrowPrev';
import { CART_PAGE_CONSTANTS } from '../../Constants/CartPageConstants';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getFullImagePath,
  isEmptyEvery,
  getPriceWithExtractingJsonHelper,
  getUserType,
  getPrice,
} from 'common/utilities/utils';
import ImageComponent from 'atoms/Image';
import { fetchItemDetailsAction } from '@kfc-global/react-shared/redux/Actions/MenuAction';
import { addItemToCartAction, setUserLastActiveTime } from '@kfc-global/react-shared/redux/Actions/CartAction';
import { UserOrderContext } from 'context/context';
import BucketIcon from 'styles/staticAssets/images/Icon_Add_to_Cart.svg';
import { logAddToCartEvent } from 'organisms/MenuPDPPage/Presentation/ReusableComponents/PdpAnalytics';
import { ANALYTICS_SHARED_CONSTANTS } from 'common/constants/SharedConstants';

export const setPrevArrowCSS = currentSlide => {
  let elmnt = document.getElementsByClassName('slick-prev')[0] || {
    style: {
      display: 'block',
    },
  };
  if (currentSlide > 0) {
    elmnt.style.display = 'block';
  } else {
    elmnt.style.display = 'none';
  }
};

const getTrackMaxCount = SLIDES_TO_SHOW => {
  const maxWidth = window.innerWidth;
  if (maxWidth > 1350 && maxWidth < 1650) {
    return 4;
  } else if (maxWidth > 1650 && maxWidth <= 1920) {
    return 5;
  }
  return SLIDES_TO_SHOW;
};
const IndulgentAddOn = props => {
  const { isMobile, IndulgentData } = props;
  const { INDULGENT_ADD_ON, ADD_TO_CART_CLICK } = CART_PAGE_CONSTANTS;
  const { HEADER, SLIDES_TO_SCROLL, SLIDES_TO_SHOW, ADD_TO_CART } = INDULGENT_ADD_ON;
  const [currentSlide, updateCurrentSlide] = useState(0);
  const [rangeValue, updateRangeValue] = useState(0);
  const [caroselCount, setCaroselCount] = useState(1);
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext);
  const dispatch = useDispatch();
  const { cartReducer, userParams, tenantReducer, menuReducer } = useSelector(data => {
    return {
      cartReducer: data.cartReducer || {},
      userParams: data.appStateReducer.userStatus || {},
      tenantReducer: data.tenantReducer || {},
      menuReducer: data.menuReducer || {},
    };
  });
  const { loggedIn, localized } = userParams;
  const userType = getUserType(localized, loggedIn);
  const { flatResponse = {} } = menuReducer || {};
  /* *
   * This fucntion is part of RENDEV-10995 we need to show the price without tax in UI
   */

  const {
    currencyConversionFactor,
    componentOptions: { web: { global: { showPriceWithTax = false } = {} } = {} } = {},
  } = tenantReducer;

  const dispositionNew = isEmptyEvery(userOrderState.dispositionNew)
    ? JSON.parse(localStorage.getItem('dispositionNew'))
    : userOrderState.dispositionNew;
  const storeInfo = dispositionNew ? dispositionNew.store : {};
  const catalogs =
    (storeInfo?.summary?.menu?.catalogs?.length && storeInfo?.summary?.menu?.catalogs[0]) ||
    tenantReducer?.genericMenuName ||
    '';

  const carousal = React.useRef(null);

  const onNextCard = () => {
    if (currentSlide < IndulgentData.length - 1) {
      let updatedCurrentSlide = 0;
      if (currentSlide + SLIDES_TO_SCROLL > IndulgentData.length - SLIDES_TO_SHOW - 1) {
        updatedCurrentSlide = IndulgentData.length - SLIDES_TO_SHOW;
      } else {
        updatedCurrentSlide = currentSlide + SLIDES_TO_SCROLL;
      }
      setPrevArrowCSS(updatedCurrentSlide);
      updateCurrentSlide(updatedCurrentSlide);
      carousal.current.slickGoTo(updatedCurrentSlide);
    }
  };
  /* OnClicking Previous Arrow Button */
  const onPrevCard = () => {
    if (currentSlide > 0) {
      updateCurrentSlide(currentSlide - SLIDES_TO_SCROLL);
      carousal.current.slickGoTo(currentSlide - SLIDES_TO_SCROLL);
    }
    setPrevArrowCSS(currentSlide - SLIDES_TO_SCROLL);
  };

  const onUpdateRange = e => {
    updateRangeValue(e.target.value);
    carousal.current.slickGoTo(e.target.value);
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: SLIDES_TO_SHOW,
    slidesToScroll: SLIDES_TO_SCROLL,
    arrows: true,
    adaptiveHeight: false,
    autoplay: false,
    nextArrow: <SampleArrowNext clickNextCard={onNextCard} />,
    prevArrow: <SampleArrowPrev clickPrevCard={onPrevCard} />,
    beforeChange: (current, next) => updateRangeValue(next),
    afterChange: (current, prev) => updateCurrentSlide(current),
    variableWidth: true,
    accessibility: true,
    responsive: [
      {
        breakpoint: 2600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1720,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
          variableWidth: true,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          swipeToSlide: true,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          swipeToSlide: true,
          beforeChange: (current, next) => {
            setCaroselCount(Math.round(next + 1));
          },
        },
      },
    ],
  };

  const addToCartHandler = ({ index, id, customizable, IndulgentAddonData }) => {
    const catId = id?.split('_')[0] || '';
    const { categoryId: productCatId = '' } = flatResponse?.productMapById?.[catId] ?? {};
    const {
      id: categoryId = '',
      name: categoryName = '',
      url: categoryUrl = '',
    } = flatResponse?.categoryMapById?.[productCatId] ?? {};
    const product = IndulgentAddonData?.filter(item => id === item.id)[0];
    const availabilityObj = product?.availability && product?.availability?.[0];
    if (userParams.localized) {
      if (!customizable) {
        dispatch(
          addItemToCartAction(
            {
              params: {
                basketId: cartReducer && cartReducer.cartData && cartReducer.cartData.id,
              },
              tenantId: tenantReducer.tenantId,
            },
            [{ Id: id, categoryId: categoryId, quantity: 1, modGrps: [], categoryName, categoryUrl }],
          ),
        );
        dispatch(setUserLastActiveTime(new Date()));
      } else {
        dispatch(
          fetchItemDetailsAction({
            tenantId: tenantReducer.tenantId,
            catalogName: catalogs,
            itemId: id,
          }),
        );
      }
    } else {
      userOrderStateDispatch({
        type: ADD_TO_CART_CLICK,
        value: {
          addToCart: true,
          productItemId: id,
          categoryId: categoryId,
          oldProduct: product,
          customizable: customizable,
          catalogs: catalogs,
          fromPdpPage: false,
        },
      });
    }
    const itemsList = [
      {
        item_name: product?.dname[0]?.value,
        item_id: id,
        price: +getPrice(availabilityObj, tenantReducer?.currencyConversionFactor).toFixed(2),
        coupon: '',
        currency: tenantReducer?.currencyShortName,
        discount: 0,
        item_category: categoryName,
        item_list_name: ANALYTICS_SHARED_CONSTANTS.CART_CROSS_SELL,
        item_list_id: categoryId,
        index: index,
        quantity: 1,
      },
    ];
    const totalAmount = +getPrice(availabilityObj, tenantReducer?.currencyConversionFactor).toFixed(2);
    logAddToCartEvent(userType, itemsList, totalAmount);
  };
  return (
    <div className='indulgent-container'>
      <div className='indulgent-header-container' role='heading' aria-level='2'>
        <span className='indulgent-header'>{translateWithI18Next(HEADER)}</span>
        {isMobile ? (
          <span className='indulgent-carousal-count' data-testid='indulgent-count-test'>
            {caroselCount}/{IndulgentData && IndulgentData.length}
          </span>
        ) : null}
      </div>
      <div className='indulgent-card-list'>
        <CarauselComp settings={settings} carousalRef={carousal}>
          {IndulgentData.map((item, index) => {
            return (
              <div key={index} className='indulgent-card'>
                <ImageComponent
                  data-testid=''
                  className='indulgent-card-image'
                  defaultPath={getFullImagePath(null, tenantReducer, true)}
                  srcFile={getFullImagePath(item.imageName, tenantReducer)}
                />
                <div className='indulgent-card-content'>
                  <div className='indulgent-card-header'>{item.dname[0].value}</div>
                  <div className='indulgent-card-price'>
                    {tenantReducer.currencySymbol}
                    {getPriceWithExtractingJsonHelper(
                      item?.availability[0],
                      item?.additionalProperties,
                      currencyConversionFactor,
                      showPriceWithTax,
                    )}
                  </div>
                  <ButtonComp
                    className='button redButton indulgent-card-button'
                    aria-label={translateWithI18Next(ADD_TO_CART) + ' ' + item.dname[0].value}
                    data-testid='add-to-cart'
                    onClickHandler={e => {
                      addToCartHandler({
                        index: index,
                        id: item?.id,
                        customizable: false,
                        IndulgentAddonData: IndulgentData,
                      });
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                  >
                    {translateWithI18Next(ADD_TO_CART)}
                    <ImageComponent className='add-to-cart-Icon' srcFile={BucketIcon} />
                  </ButtonComp>
                </div>
              </div>
            );
          })}
        </CarauselComp>
      </div>
      {isMobile || IndulgentData.length < 3 ? null : (
        <div className='indulgent-slideContainer' data-testid='indulgent-mobile-test'>
          <input
            className='indulgent-slider'
            type='range'
            min='0'
            max={IndulgentData.length - getTrackMaxCount(SLIDES_TO_SHOW)}
            value={rangeValue}
            id='myRange'
            onChange={onUpdateRange}
          />
        </div>
      )}
    </div>
  );
};

export default IndulgentAddOn;
